import { Modal } from "react-bootstrap";
import "./WidgetItemPriority.css"
import { useDispatch, useSelector } from "react-redux";
import { loadPriority } from '../../../reducers/models/widgetData';
import { useEffect, useState } from "react";
import { faSignal, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import ErrorAdd from "../../../util/ErrorAdd";

function WidgetItemPriority({ idObject, idItem, idWidget, number, editMode, added, onlyRead }) {

    /*
        idObject:
        1	Задача
        2	Регулярная задача
        6   Регулярная задача. Трекер
        3	Доска
        4	Проект
        5	Пользователь
        editMode - Режим редактирования виджетов
        added - true при событии добавления виджета
    */
    const dispatch = useDispatch()

    const stateTaskList = useSelector((state) => state.taskList);
    const stateTaskRlist = useSelector((state) => state.taskRlist);
    const stateBoardTasklist = useSelector((state) => state.boardTaskList);

    const [edit, setEdit] = useState(false);
    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);
    const [idPriority, setIdPriority] = useState(null);

    useEffect(() => {
        if (idObject === 1) {
            if (stateTaskList.list.filter(a => a.ID === idItem).length > 0) {
                setIdPriority(stateTaskList.list.filter(a => a.ID === idItem)[0].Priority);
            }
        }
        else if (idObject === 2) {
            if (stateTaskRlist.list.filter(a => a.ID === idItem).length > 0) {
                setIdPriority(stateTaskRlist.list.filter(a => a.ID === idItem)[0].Priority);
            }
        }
        else if (idObject === 3) {
            if (stateBoardTasklist.list.filter(a => a.ID === idItem).length > 0) {
                setIdPriority(stateBoardTasklist.list.filter(a => a.ID === idItem)[0].Priority);
            }
        }
    }, [idItem, stateTaskList.list, stateTaskRlist.list, stateBoardTasklist.list]);


    useEffect(() => {
        if (added !== null & added !== undefined) {
            //Ограничение на добавление виджета определенного номера. Иначе открываются сразу все виджеты
            if (added.idWidget === idWidget & added.number === number) {
                setEdit(true);
            }
        }
    }, [added]);

    function updateHandler(val) {
        if (idObject === 1) {
            axios.post('/api_tracker/task/updatePriority', { ID_Task: idItem, Priority: val })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else if (idObject === 2) {
            axios.post('/api_tracker/taskR/updatePriority', { ID_TaskR: idItem, Priority: val })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else if (idObject === 3) {
            axios.post('/api_tracker/board/taskUpdatePriority', { ID: idItem, Priority: val })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        <div>
            <button className={'p-0 priority_button priority_bg_color_' + idPriority} style={{ width: '100px', justifyContent: 'flex-end' }} onClick={() => { onlyRead === false && setEdit(true) }}>
                <FontAwesomeIcon icon={faSignal} className="mr-5" />
            </button>

            {edit === true &&
                <div>
                    <Modal show={edit} onHide={() => setEdit(false)} size="sm">
                        <Modal.Body>
                            <div className="modal_close" onClick={() => setEdit(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                            <div className="modal_title text-center">Выберите приоритет</div>
                            <div className="row mt-15">
                                <div className="col-md-12">
                                    <button className="priority_button priority_bg_color_0" onClick={() => updateHandler(0)} >
                                        Без приоритета
                                    </button>
                                </div>
                                <div className="col-md-12 mt-10">
                                    <button className="priority_button priority_bg_color_1" onClick={() => updateHandler(1)}>
                                        1
                                    </button>
                                </div>
                                <div className="col-md-12 mt-10">
                                    <button className="priority_button priority_bg_color_2" onClick={() => updateHandler(2)}>
                                        2
                                    </button>
                                </div>
                                <div className="col-md-12 mt-10">
                                    <button className="priority_button priority_bg_color_3" onClick={() => updateHandler(3)}>
                                        3
                                    </button>
                                </div>
                                <div className="col-md-12 mt-10">
                                    <button className="priority_button priority_bg_color_4" onClick={() => updateHandler(4)}>
                                        4
                                    </button>
                                </div>
                                <div className="col-md-12 mt-10">
                                    <button className="priority_button priority_bg_color_5" onClick={() => updateHandler(5)}>
                                        5
                                    </button>
                                </div>
                                <div className="col-md-12 mt-10">
                                    <button className="priority_button priority_bg_color_6" onClick={() => updateHandler(6)}>
                                        6
                                    </button>
                                </div>
                            </div>
                            {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                        </Modal.Body>
                    </Modal>
                </div>
            }

        </div>
    )
}

export default WidgetItemPriority;